export default __webpack_public_path__ + "static/media/left.55d9eee7.svg";